export const COOKIES = {
  TOKEN: 'prop.session-token',
};
